const STORAGE_KEY = "klupz.activeClubId";

export const getStoredClubId = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setStoredClubId = (clubId: string) => {
  try {
    localStorage.setItem(STORAGE_KEY, clubId);
  } catch {}
};
